import React from 'react';
import Slider from 'react-simple-range';
import { actions } from "react-redux-form";
import { connect } from "react-redux";

import './range-slider.css';

class RangeSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    }
  }

  handleChange(event) {
    const {model, dispatch} = this.props;
    const value = event.value;
    this.setState({value: value});

    if (model) {
      dispatch(actions.change(model, value))
    }

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render() {
    const unit = this.props.unit || '%';
    const ignoreDynamicMeter = this.props.ignoreDynamicMeter;

    return (
      <div className="fluid Ignite-range-slider">
        <div className="Ignite-range-slider-inner">
          <div className="Ignite-range-slider-label-from">
            {this.props.labels.start}
            <br/>
            {!ignoreDynamicMeter &&
            this.state.value + '' + unit
            }
          </div>
          <div className="Ignite-range-slider-label-to">
            {this.props.labels.end}
            <br/>
            {!ignoreDynamicMeter &&
            this.props.max - this.state.value + '' + unit
            }
          </div>
          <Slider onChange={event => this.handleChange(event)}
                  sliderSize={4}
                  thumbSize={18}
                  sliderColor="#df4a6b"
                  trackColor="#ab1738"
                  thumbColor="#ab1738"
                  value={this.state.value}
                  min={this.props.min}
                  max={this.props.max}
                  className="range-slider"
          />
        </div>
      </div>
    );
  }
}

RangeSlider.defaultProps = {
  step: 0,
  min: 0,
  labels: {
    start: '',
    end: '',
  }
};

export default connect()(RangeSlider);



// WEBPACK FOOTER //
// ./src/components/common/form/range-slider.jsx